import auth from "./AuthService";
import Constants from "./Constants";

class LinkType {
	name;
	index;
	api;
	#parser;

	constructor(name, index, api, parser) {
		this.name = name;
		this.index = index;
		this.api = api;
		this.#parser = parser;
	}

	parse(data, link) {
		return this.#parser(data, link, this.index);
	}
}

export default {

	data: [],

	loadPromise: null,

	linkTypes: [
		new LinkType("新闻", 0, `${Constants.adminBackend}/links/news/`,
			(data, link, index) => {
				if (link.startsWith("/news/")) {
					return data[index][link];
				}
			}),
		new LinkType("文档", 1, `${Constants.backend}/downloads/`,
			(data, link, index) => {
				if (link.startsWith("/docs/")) {
					return data[index][link];
				}
			}),
		new LinkType("产品类别", 2, `${Constants.adminBackend}/links/categories/`,
			(data, link, index) => {
				if (link.startsWith("/categories/")) {
					return data[index][link];
				}
			}),
		new LinkType("产品页", 3, `${Constants.adminBackend}/links/products/`,
			(data, link, index) => {
				if (link.startsWith("/details/")) {
					return data[index][link];
				}
			}),
		new LinkType("自定义", 4, "", (ignored, link) => {
			return link;
		})
	],

	parse(link) {
		for (let x of this.linkTypes) {
			let parseResult = x.parse(this.data, link);
			if (parseResult) {
				return {
					index: x.index,
					result: parseResult
				};
			}
		}
		return {
			index: this.linkTypes.length - 1,
			result: link
		}
	},

	load() {
		if (!this.loadPromise) {
			this.loadPromise = new Promise((resolve, reject) => {
				let count = this.linkTypes.length - 1;
				for (let x of this.linkTypes) {
					if (!x.api) {
						continue;
					}
					this.data[x.index] = {};
					auth.axios().get(x.api).then(res => {
						for (let entry of res.data) {
							if (!this.data[x.index][entry.link]) {
								this.data[x.index][entry.link] = entry.name;
							} else {
								this.data[x.index][entry.link] += "/" + entry.name;
							}
						}
					}).catch(e => {
						reject(e);
					}).finally(() => {
						count--;
						if (count === 0) {
							this.loadPromise = null;
							resolve();
						}
					});
				}
			});
		}
		return this.loadPromise;
	},

	getNames() {
		return this.linkTypes.map(x => x.name);
	}
};